import { Form, ButtonLoader } from '@wellesley/ui'
import { FC } from 'react'
import CommonFormField from 'components/form/CommonFormField'
import { useForm } from './hooks/useForm'

import { AppsLink } from '@wellesley/router'
import { fixedCacheKey, useSubmit } from './hooks/useSubmit'
import { AtSign } from 'lucide-react'
import { usePostApiV1AccountsSignupMutation } from '../../../authApi'
import {
  displaynameMaxLength,
  emailMaxLength,
  maxPwdLength,
  usernameMaxLength,
  pwdCaption,
} from '@wellesley/forms'

export const SignUpForm: FC = () => {
  const { onSubmit } = useSubmit()
  const { form, isUserNameChecked, handleUserNameChange, handleUserNameBlur } =
    useForm()
  const { control, handleSubmit } = form
  const [, { isLoading }] = usePostApiV1AccountsSignupMutation({
    fixedCacheKey,
  })
  const isDirty =
    Object.keys(form.formState.dirtyFields).length ===
    Object.keys(form.getValues()).length

  const canSubmit = isDirty && isUserNameChecked && form.formState.isValid

  return (
    <Form {...form}>
      <form onSubmit={(...args) => void handleSubmit(onSubmit)(...args)}>
        <div className="pt-m md:w-[450px]">
          <div className="flex w-full flex-col gap-s">
            <CommonFormField
              maxChars={displaynameMaxLength}
              control={control}
              name="displayName"
              displayName="Display name"
              onAddEmoji={(text, field) => field?.onChange(text)}
            />
            <CommonFormField
              control={control}
              icon={<AtSign />}
              name="userName"
              noSpaces
              displayName="Username"
              maxChars={usernameMaxLength}
              onFieldChange={handleUserNameChange}
              onBlur={() => void handleUserNameBlur()}
            />
            <CommonFormField
              type="email"
              control={control}
              name="email"
              displayName="Email"
              maxChars={emailMaxLength}
            />
            <CommonFormField
              type="password"
              control={control}
              name="password"
              displayName="Password"
              maxChars={maxPwdLength}
              description={pwdCaption}
            />
          </div>

          <div className="mt-xl flex items-center justify-between">
            <div className="flex flex-col">
              <div className="text-sm font-medium text-gray-500">
                By creating account you agree to the
              </div>
              <div className="mt-xxxs flex gap-xxs text-sm font-normal text-gray-700">
                <AppsLink to="/terms" className="underline">
                  Terms of Service
                </AppsLink>
                <span className="text-gray-500">and</span>
                <AppsLink to="/privacy" className="underline">
                  Privacy Policy
                </AppsLink>
              </div>
            </div>
            <ButtonLoader
              disabled={!canSubmit}
              isLoading={isLoading}
              type="submit"
            >
              Create account
            </ButtonLoader>
          </div>
        </div>
      </form>
    </Form>
  )
}
